// components
import { CenterPageTemplate } from '@/pwa/templates/CenterPageTemplate/CenterPageTemplate';
import { FloatingContent } from '@/pwa/molecules/FloatingContent/FloatingContent';

export interface AccessVerifiedV2Props {
  onContinue: () => void;
}

export const AccessVerifiedV2 = ({ onContinue }: AccessVerifiedV2Props) => {
  return (
    <CenterPageTemplate>
      <FloatingContent
        title='Access Verified'
        description="You now have full access to KareHero. To get you started, we'll ask you a few questions about your current situation to ensure we provide the best service possible. It will only take a minute."
        actions={[
          {
            label: 'Continue To Onboarding',
            variant: 'primary',
            onClick: onContinue,
          },
        ]}
      />
    </CenterPageTemplate>
  );
};

AccessVerifiedV2.displayName = 'AccessVerifiedV2';
export default AccessVerifiedV2;
